import { FormPayload } from '../types';
import { getBaseHostUrl } from '../../../../Utils/URL/Hosts/BaseHostUtils';

export const toForgotPasswordAPI = (payload: FormPayload) => {
  return fetch(`${getBaseHostUrl()}/api/auth/forgot-password`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  }).then(async r => {
    if (r.status >= 400) {
      throw await r.text();
    }

    return r;
  });
};
